<script setup lang="ts">
import type { CandidatesFeatures } from "@/types/marketing";
import { useIntersectionAnimation } from "@/composables/use-intersection-animation";
import CandidatesFeatureSection from "./CandidatesFeatureSection.vue";

interface Props {
  content: CandidatesFeatures;
}

defineProps<Props>();
const { elementRef: headerRef } = useIntersectionAnimation({ threshold: 0.2 });
</script>

<template>
  <section class="relative overflow-hidden">
    <!-- Section Header -->
    <div ref="headerRef" class="py-16 lg:py-24 2xl:py-32 3xl:py-40 4xl:py-48 bg-warm-white">
      <div class="max-w-[1400px] 2xl:max-w-[1600px] 3xl:max-w-[1800px] 4xl:max-w-[2200px] mx-auto px-4 sm:px-6 lg:px-8 2xl:px-12 3xl:px-16 4xl:px-20">
        <div class="text-center max-w-3xl 2xl:max-w-4xl 3xl:max-w-5xl 4xl:max-w-6xl mx-auto fade-up">
          <div class="badge-hospitality inline-flex mb-6 2xl:mb-8 3xl:mb-10 2xl:text-base 3xl:text-lg 4xl:text-xl">
            <span class="badge-hospitality-text">
              {{ content.sectionSubtitle }}
            </span>
          </div>

          <h2 class="font-secondary text-3xl md:text-4xl lg:text-5xl 2xl:text-6xl 3xl:text-7xl 4xl:text-8xl font-bold tracking-tight text-dark-gray mb-6 2xl:mb-8 3xl:mb-10 !pt-0 !pb-0">
            {{ content.sectionTitle }}
          </h2>

          <p class="text-lg 2xl:text-xl 3xl:text-2xl 4xl:text-3xl text-medium-gray">
            {{ content.sectionDescription }}
          </p>
        </div>
      </div>
    </div>

    <!-- Feature Sections -->
    <CandidatesFeatureSection
      v-for="(step, index) in content.steps"
      :key="step.id"
      :step="step"
      :index="index"
    />
  </section>
</template>
